import { IZone, ITable } from './../../interfaces/index';
import { getStoreAccessors } from "typesafe-vuex";
import { State } from "../state";
import { IAdminTablesState } from "./state";


export const mutations = {
    setZones(state: IAdminTablesState, payload: IZone[]) {
        state.zones = payload;
    },
    setTables(state: IAdminTablesState, payload: ITable[]) {
        state.tables = payload;
    },
    setZone(state: IAdminTablesState, payload: IZone) {
        const idx = state.zones.findIndex((v: IZone) => v.id === payload.id);
        if (idx >= 0) {
            state.zones[idx] = payload;
        } else {
            state.zones.push(payload);
        }
    },
    setTable(state: IAdminTablesState, payload: ITable) {
        const idx = state.tables.findIndex((v: ITable) => v.id === payload.id);
        if (idx >= 0) {
            state.tables[idx] = payload;
        } else {
            state.tables.push(payload);
        }
    },
    removeZone(state: IAdminTablesState, payload: number) {
        const idx = state.zones.findIndex((v: IZone) => v.id === payload);
        if (idx >= 0) {
            state.zones.splice(idx, 1);
        }
    },
    removeTable(state: IAdminTablesState, payload: number) {
        const idx = state.tables.findIndex((v: ITable) => v.id === payload);
        if (idx >= 0) {
            state.tables.splice(idx, 1);
        }
    },

    removeTableFromZone(state: IAdminTablesState, payload: {tableId: number, zoneId: number}) {
        const zoneIdx = state.zones.findIndex((v: IZone) => v.id === payload.zoneId);
        if (zoneIdx >= 0) {
            const tableIdx = state.zones[zoneIdx].tables.findIndex((v: ITable) => v.id === payload.tableId);
            if (tableIdx >= 0) {
                state.zones[zoneIdx].tables.splice(tableIdx, 1);
            }
        }
    }

};

const { commit } = getStoreAccessors<IAdminTablesState, State>('');

export const commitSetZones = commit(mutations.setZones);
export const commitSetTables = commit(mutations.setTables);
export const commitSetZone = commit(mutations.setZone);
export const commitSetTable = commit(mutations.setTable);
export const commitRemoveZone = commit(mutations.removeZone);
export const commitRemoveTable = commit(mutations.removeTable);
export const commitRemoveTableFromZone = commit(mutations.removeTableFromZone);